import {DISTANCE_MATRIX} from "../types";
import { setErrors } from "../actions/errorActions";


export const get_distance_matrix = (data) => (dispatch) => {
  try {
    dispatch({ type: DISTANCE_MATRIX, payload:data });
  }catch(err){
    dispatch(setErrors(err));
  }
};